var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"mode":"out-in","name":"pages"}},[_c('router-view')],1),(_vm.loading)?_c('Loading'):_vm._e(),_c('cookie-policy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }